<template>
  <div id="app">
    <div class="user-list">
      <div v-for="(user,index) in userInfo.userRelList">
        <div class="user-simple" v-if="user.orders == 1 && user.status == 1">
          <div class="miyou">
            <span>聊天号</span>
          </div>
          <div class="miyounum">
            <span>{{ user.code }}</span>
          </div>
          <div class="miyoudian" @click="setPass(user.code)">
            <span>点我免费开通</span>
          </div>
        </div>
        <div class="user-simple" v-if="user.orders == 1 && user.status == 2">
          <div class="miyou">
            <span>聊天号</span>
          </div>
          <div class="miyounum">
            <span>{{ user.code }}</span>
          </div>
          <div class="miyoudian_div" >
            <!-- <button class="miyoudian-lt" @click="toDown(user.code)">开始伪装聊天</button> -->
             <button class="miyoudian-lt" @click="changePass(user.code,user.orders)" >修改密码</button>
            <!-- <a class="miyoudian-a" @click="changePass(user.code,user.orders)" >修改密码</a> -->
          </div>
        </div>
        <div class="user-simple-pass" v-else-if="user.orders == 1 && user.status == 3">
          <div class="user-simple-logo">
            <img src="http://img3.imgtn.bdimg.com/it/u=378824344,1185609431&fm=26&gp=0.jpg" alt />
          </div>
          <div class="user-simple-info">
            <div class="user-simple-info-name">{{ user.displayName }}</div>
            <div style="margin-top: 6px;">
              <div class="content">
                <span>聊天号</span>
              </div>
              <div class="num">
                <span>{{ user.code }}</span>
              </div>
            </div>
          </div>
          <div class="user-simple-button" @click="changePass(user.code)">
            <span>修改密码</span>
          </div>
        </div>

        <div class="user-simple" v-else-if="user.orders > 1 && user.status == 0 ">
          <div class="right-image">
            <img src="../../assets/img/VIP@2x.png" />
          </div>
          <div class="miyou">
            <span style=" color:rgba(134,139,164,1);">聊天号</span>
          </div>
          <div class="miyounum">
            <span class="unopen-color" style=" color:rgba(134,139,164,1);">{{ user.code }}</span>
          </div>
          <div class="miyounum-div">
            <span class="unopen">待开通</span>
            <br />
            <button class="user-open" @click="tovip">立即开通</button>
          </div>
        </div>

        <div class="user-simple" v-else-if="user.orders > 1 && user.status == 1 &&  user.overflag ">
          <div class="miyou">
            <span>聊天号</span>
          </div>
          <div class="miyounum">
            <span>{{ user.code }}</span>
          </div>
          <div class="miyoudian">
            <span @click="setPass(user.code)">点我立即使用</span>
          </div>
        </div>
        <!-- vip用户状态 -->
        <div class="user-simple" v-if="user.orders > 1 && user.status == 2 &&  user.overflag ">
          <div class="miyou">
            <span>聊天号</span>
          </div>
          <div class="miyounum">
            <span>{{ user.code }}</span>
          </div>
          <div class="miyoudian_div" >
            <!-- <button class="miyoudian-lt" @click="toDown(user.code)">开始伪装聊天</button>
            <a class="miyoudian-a" @click="changePass(user.code,user.orders)" >修改密码</a> -->
            <button class="miyoudian-lt" @click="changePass(user.code,user.orders)" >修改密码</button>
          </div>
        </div>
        <div
          class="user-simple-pass"
          v-else-if="user.orders > 1 && user.status == 3 &&  user.overflag "
        >
          <div class="user-simple-logo">
            <img src="http://img3.imgtn.bdimg.com/it/u=378824344,1185609431&fm=26&gp=0.jpg" alt />
          </div>
          <div class="user-simple-info">
            <div class="user-simple-info-name">{{ user.displayName }}</div>
            <div style="margin-top: 6px;">
              <div class="content">
                <span>聊天号</span>
              </div>
              <div class="num">
                <span>{{ user.code }}</span>
              </div>
            </div>
          </div>
          <div class="user-simple-button" @click="changePass(user.code)">
            <span>修改密码</span>
          </div>
        </div>

        <div
          class="user-simple"
          v-else-if="user.orders > 1 && (user.status == 1 || user.status == 2 || user.status == 3) &&  !user.overflag"
        >
          <div class="right-image">
            <img src="../../assets/img/VIP@2x.png" />
          </div>
          <div class="miyou">
            <span style=" color:rgba(134,139,164,1);">聊天号</span>
          </div>
          <div class="miyounum">
            <span class="unopen-color" style=" color:rgba(134,139,164,1);">{{ user.code }}</span>
          </div>
          <div class="miyounum-div">
            <span class="unopen">待开通</span>
            <br />
            <button class="user-open" @click="tovip">立即续费</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import api from "../../api/index";
import tips from "@/estoast";

export default {
  name: "app",
  data() {
    return {
      msg: "注册协议",
      userInfo: {},
      validitydate: ""
    };
  },
  created: function() {
    //this.changeUserInfo();
  },
  mounted() {
    this.userInfo = this.getUserInfo;
  },
  watch: {
    getUserInfo: function(newVal, oldVal) {
      console.log(JSON.stringify("userInfo 被修改"));
      // console.log(JSON.stringify(newVal))
      // console.log(JSON.stringify(oldVal))
      this.userInfo = newVal;
    }
  },
  methods: {
    setPass: function(num) {
      this.$router.push({ name: "setPass", params: { code: num } });
    },
    changePass: function(num) {
      this.$router.push({ name: "changePass", params: { code: num } });
    },
    tovip: function() {
      this.$router.push("/vip");
    },
    toDown: function(num) {
      this.$router.push({ name: "downapp", params: { code: num } });
    },
    changePass: function(num,orders) {
      
      var validitydate = this.userInfo.validitydate;
      var timestamp = Date.parse(new Date());
      var validitydate=new Date(validitydate).getTime();
      console.log(JSON.stringify(" validitydate:"+validitydate+" \t timestamp:"+timestamp));

      //判断是否过   聊天号暂时无法使用，请先购买VIP
      var _this =this;
      if( orders != 1 && this.overflag){
          tips.toast(' 聊天号暂时无法使用，请先购买VIP');
          setTimeout(function () {
              _this.$router.push("pay");
          }, 1500);
       }else{
          this.$router.push({ name: "changePassConfirmApp", params: { code: num } });
        }


    },
    changeUserInfo: function() {
      this.$axiosHttp({
        method: "POST",
        url: api.qml.getuserInfo,
        data: { flag: 1 }
      })
        .then(res => {
          if (res.code == 0) {
            if (res.result != null) {
              this.userInfo = res.result;
            } else {
              this.userInfo = this.getUserInfo;
            }
            store.commit(types.SET_USERINFO, res.result);
            store.commit(types.SET_USERLIST, res.result.userRelList);
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
    }
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  }
};
</script>
<style  scoped>
.user-list {
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
}
.user-list ul {
  width: 100%;
  height: auto;
}

.user-simple {
  width: 625px;
  height: 152px;
  background: rgba(29, 33, 75, 1);
  border-radius: 24px;
  border: 2px solid rgba(255, 255, 255, 0.21);
  list-style: none;
  margin: 0 auto;
  display: flex;
  margin: 46px auto 0 auto;
}

.miyou {
  width: 95px;
  height: 40px;
  margin: 56px 0 0 30px;
  top: 56px;
  left: 30px;
}
.miyou span {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
}

.miyounum {
  width: 180px;
  height: 50px;
  margin: 50px 0 0 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1;
  text-align: left;
}
.unopen-color {
  color: rgba(134, 139, 164, 1);
}

.miyounum span {
  font-size: 42px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: rgba(245, 195, 167, 1);
  line-height: 50px;
}

.miyoudian_div {
  width: 200px;
  height: 100%;
}

.miyoudian {
  width: 200px;
  height: 52px;
  background: url("../../assets/img/miyoudian@2x.png");
  background-size: 100% 100%;
  position: relative;
  top: 50px;
  right: 20px;
  border: none;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 52px;
}
.miyoudian-lt {
  width: 200px;
  height: 52px;
  background: url("../../assets/img/miyoudian@2x.png");
  background-size: 100% 100%;
  position: relative;
  top: 50px;
  right: 20px;
  border: none;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 52px;
}
.miyoudian-a {
  display: block;
  height: 52px;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 50px;
  color: #eeeeee;
  opacity: 1;
  margin:48px 0 0 -15px;
}
.miyoudian-a::after{
  content: '';
  background-image: url('../../assets/img/jiantou.png');
  background-size: 100% 100%;
  position:absolute;
  height: 24px;
  width: 15px;
  margin:12px 0 0 10px;


}

.miyounum-div {
  width: 200px;
  height: 48px;
  border-radius: 24px;
  position: relative;
  top: 20px;
  right: 20px;
}

.miyoudian span {
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 48px;
}

.right-image {
  width: 60px;
  height: 32px;
  background: rgba(29, 33, 75, 1);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.21);
  position: absolute;
}
.right-image img {
  width: 100%;
  height: 100%;
}
.unopen {
  width: 72px;
  height: 34px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(134, 139, 164, 1);
  line-height: 54px;
}

.user-open {
  width: 100%;
  height: 52px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 52px;
  background: url("../../assets/img/miyoudian@2x.png");
  background-size: 100% 100%;
  border-radius: 24px;
  border: none;
}
.user-simple-log {
  width: 72px;
  height: 72px;
  display: flex;
}
.user-simple-log img {
  width: 72px;
  height: 72px;
  border-radius: 55px;
}

.user-simple-pass {
  width: 616px;
  height: 152px;
  background: rgba(29, 33, 75, 1);
  border-radius: 24px;
  border: 2px solid rgba(255, 255, 255, 0.21);
  list-style: none;
  margin: 46px auto 0 auto;
  display: flex;
}

.user-simple-logo {
  width: 72px;
  height: 72px;
  border-radius: 55px;
  left: 34px;
  margin: 40px 22px 0 34px;
}

.user-simple-logo img {
  width: 72px;
  height: 72px;
  border-radius: 55px;
}

.user-simple-info {
  flex: 1;
}
.user-simple-info p {
  text-align: inherit;
}
.user-simple-info-name {
  width: 100%;
  height: 40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  margin: 35px 0px 0px 0px;
  text-align: left;
  overflow: hidden;
}

.user-simple-info .content {
  width: 72px;
  height: 30px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 30px;
  float: left;
}
.user-simple-info .num {
  width: 160px;
  height: 48px;
  border-radius: 24px;
  opacity: 0.16269999999999998;
  border: 1px solid rgba(229, 229, 229, 1);
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 48px;
  float: left;

  margin: 0px 0px 22px 6px;
}
.user-simple-info .num span {
  color: #f5c3a7;
}

.user-simple-button {
  width: 184px;
  height: 52px;
  background: url("../../assets/img/miyoudian@2x.png");
  background-size: 100% 100%;
  border-radius: 24px;
  border: 4px solid rgba(255, 227, 205, 1);
  margin: 46px 24px 34px 0px;
}
.user-simple-button span {
  height: 52px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 52px;
}

.miyoudian:active,
.user-simple-button:active,
.user-open:active {
  background: rgba(216, 216, 216, 1);
}
</style>


// WEBPACK FOOTER //
// src/components/common/centerUserList.vue